<template>
  <main>
    <VuePerfectScrollbar
      class="scroll-area"
      :settings="psSettings"
      @ps-scroll-y="scrollHandle"
    >
      <div class="email-app m-2 rounded mr-4">
        <main class="message">
          <div>
            <b>Message</b>
            <div class="btn-group float-right" v-if="type == 'outbox'">
              <b-button
                v-b-tooltip.hover
                title="Delete"
                @click="deleteOutboxMessage"
                variant="light"
                ><span class="icon-trash icons font-1xl"></span
              ></b-button>
              <b-button
                v-b-tooltip.hover
                title="Copy"
                variant="light"
                v-clipboard:copy="messageItem.message"
                v-clipboard:success="onCopy"
                v-clipboard:error="onCopyError"
                ><span class="fa fa-clone"></span>
              </b-button>
              <b-button
                v-b-tooltip.hover
                title="Resend"
                @click="resendMessage"
                variant="light"
                ><span class="icon-action-undo icons"></span
              ></b-button>
            </div>
            <div class="btn-group float-right" v-else-if="type == 'draft'">
              <b-button
                v-b-tooltip.hover
                title="Delete"
                @click="deleteDraftMessage"
                variant="light"
                ><span class="icon-trash icons font-1xl"></span
              ></b-button>
              <b-button v-b-tooltip.hover title="Edit" variant="light"
                ><span class="fa fa-edit"></span
              ></b-button>
              <b-button
                v-b-tooltip.hover
                title="Copy"
                variant="light"
                v-clipboard:copy="messageItem.message"
                v-clipboard:success="onCopy"
                v-clipboard:error="onCopyError"
                ><span class="fa fa-clone"></span>
              </b-button>
              <b-button
                v-b-tooltip.hover
                title="Send"
                @click="sendDraftMessage"
                variant="light"
                ><span class="fa fa-send"></span
              ></b-button>
            </div>
            <div class="btn-group float-right" v-else-if="type == 'schedule'">
              <b-button
                v-b-tooltip.hover
                title="Delete"
                @click="deleteScheduleMessage"
                variant="light"
                ><span class="icon-trash icons font-1xl"></span
              ></b-button>
              <b-button
                v-b-tooltip.hover
                title="Copy"
                variant="light"
                v-clipboard:copy="messageItem.message"
                v-clipboard:success="onCopy"
                v-clipboard:error="onCopyError"
                ><span class="fa fa-clone"></span>
              </b-button>
              <b-button
                v-b-tooltip.hover
                v-if="!messageItem.stopped"
                title="Stop"
                @click="toggleSchedule({ id: messageItem.id })"
                variant="light"
                ><span class="icon-control-pause icons font-1xl pb-1"></span
              ></b-button>
              <b-button
                v-b-tooltip.hover
                v-else
                title="Resume"
                @click="toggleSchedule({ id: messageItem.id })"
                variant="light"
                ><span class="icon-control-play icons font-1xl pb-1"></span
              ></b-button>
            </div>
          </div>
          <div class="details">
            <div class="header">
              <div class="from">
                <span>{{ messageItem.sender }}</span>
                {{ messageItem.updated_at | moment("MMMM Do YYYY, h:mm:ss a") }}
              </div>
              <div class="date">
                <span class="badge badge-success pt-2 pb-2 pl-2 pr-2">{{
                  messageItem.channel
                }}</span>
                <span class="badge badge-info ml-2 pt-2 pb-2 pl-2 pr-2">{{
                  messageItem.mode
                }}</span>
              </div>
            </div>
            <div class="content">
              <p>
                {{ messageItem.message }}
              </p>
            </div>
            <hr v-if="type != 'outbox'" />
            <div class="content" v-if="type != 'outbox'">
              <p>
                {{ messageItem.recipients }}
              </p>
            </div>
            <div class="content">
              <hr />
              <template v-if="type == 'outbox'">
                <span class="badge badge-primary badge-pill mr-2"
                  ><i class="fa fa-bell-o fa-lg"></i> Delivered -
                  {{ totalDelivered }}</span
                >
                <span class="badge badge-danger badge-pill mr-2"
                  ><i class="fa fa-bell-slash-o fa-lg"></i> Bounced -
                  {{ totalBounced }}</span
                >
              </template>
              <span class="badge badge-success badge-pill mr-2"
                ><i class="fa fa-files-o fa-lg"></i> Pages -
                {{ smsPages(messageItem.message) }}</span
              >
              <span class="badge badge-secondary badge-pill mr-2"
                ><i class="fa fa-text-width fa-lg"></i> Characters -
                {{ messageItem.message.length }}</span
              >
              <template v-if="type == 'outbox'">
                <span class="badge badge-warning badge-pill"
                  ><i class="fa fa-cubes fa-lg"></i> Units charged -
                  {{ messageItem.total_units_charged }}</span
                >
              </template>
              <!--span class="badge badge-info badge-pill">Info</span>
                    <span class="badge badge-light badge-pill">Light</span>
                    <span class="badge badge-dark badge-pill">Dark</span-->
            </div>
          </div>
        </main>
      </div>
      <div class="email-app m-2 rounded mr-4" v-if="type == 'outbox'">
        <main class="message">
          <div class="mb-2 pb-2">
            <b>Recipients ({{ messageItem.total_recipients }})</b>
            <b-dropdown class="float-right" variant="p-0" right no-caret>
              <template slot="button-content">
                <i class="icon-options-vertical icons font-1xl"></i>
              </template>
              <b-dropdown-item
                v-clipboard:copy="copyAllRecipients"
                v-clipboard:success="onCopy"
                v-clipboard:error="onCopyError"
                ><i class="fa fa-clone font-1xl padding-0"></i>Copy
                All</b-dropdown-item
              >
              <b-dropdown-item
                v-clipboard:copy="copyDeliveredRecipients"
                v-clipboard:success="onCopy"
                v-clipboard:error="onCopyError"
                ><i class="fa fa-clone font-1xl padding-0"></i
                >Delivered</b-dropdown-item
              >
              <b-dropdown-item
                v-clipboard:copy="copyUndeliveredRecipients"
                v-clipboard:success="onCopy"
                v-clipboard:error="onCopyError"
                ><i class="fa fa-clone font-1xl padding-0"></i
                >Undelivered</b-dropdown-item
              >
              <!--b-dropdown-item v-b-tooltip.hover @click="handleReloadRecipients"><i class="icon-refresh icons font-1xl padding-0"></i>Reload</b-dropdown-item-->
            </b-dropdown>
          </div>
          <v-client-table
            :columns="columns"
            :data="getSentExtra"
            :options="options"
            :theme="theme"
            id="dataTable"
          >
          </v-client-table>
        </main>
      </div>
    </VuePerfectScrollbar>
  </main>
</template>

<script>
import Vue from "vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { mapGetters, mapActions, mapState } from "vuex";
import { ClientTable, Event } from "vue-tables-2";
import { smsPages } from "@/shared/utils";

Vue.use(ClientTable);

Vue.use(VueSweetalert2);

export default {
  name: "MessageView",
  components: {
    ClientTable,
    Event,
    VuePerfectScrollbar
  },
  data: function() {
    return {
      smsPages: smsPages,
      columns: [
        "phone_no",
        "operator_name",
        "units_charged",
        "delivery_status"
      ],
      options: {
        headings: {
          name: "Recipient",
          name: "Network Operator",
          code: "Units Charged",
          uri: "Delivery Status"
        },
        sortable: ["phone_no", "operator_name", "delivery_status"],
        filterable: ["phone_no", "operator_name", "delivery_status"],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          chunk: 5,
          edge: false,
          nav: "scroll"
        }
      },
      useVuex: false,
      theme: "bootstrap4",
      template: "default"
    };
  },

  notifications: {
    showDeleteError: {
      title: "Failed",
      message: "There was error deleting this message",
      type: "error"
    },
    showDeleteSuccess: {
      title: "Success",
      message: "Message deleted successfully",
      type: "success"
    },

    copyNotifError: {
      title: "Failed",
      message: "There was error copying the content",
      type: "error"
    },
    copyNotifSuccess: {
      title: "Success",
      message: "Content copied",
      type: "success"
    },
    showSendError: {
      title: "Failed",
      message: "There was error while sending your message",
      type: "error"
    },
    showSendSuccess: {
      title: "Success",
      message: "Message was sent successfully",
      type: "success"
    }
  },
  props: {
    messageItem: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters("message", [
      "loading",
      "outbox",
      "drafts",
      "schedules",
      "serverResponse"
    ]),
    psSettings: () => {
      return {
        maxScrollbarLength: 60,
        minScrollbarLength: 40,
        suppressScrollX:
          getComputedStyle(document.querySelector("html")).direction !== "rtl",
        wheelPropagation: false,
        interceptRailY: styles => ({ ...styles, height: 0 })
      };
    },
    getSentExtra() {
      return this.messageItem.extra instanceof Promise
        ? []
        : this.messageItem.extra;
    },
    copyAllRecipients() {
      let phoneNos = "";
      if (this.messageItem.extra instanceof Promise) {
        return "";
      } else {
        for (let index = 0; index < this.messageItem.extra.length; index++) {
          if (phoneNos != "") {
            phoneNos += ", ";
          }
          phoneNos += this.messageItem.extra[index].phone_no;
        }
      }
      return phoneNos;
    },
    copyDeliveredRecipients() {
      let phoneNos = "";
      if (this.messageItem.extra instanceof Promise) {
        return "";
      } else {
        for (let index = 0; index < this.messageItem.extra.length; index++) {
          let recipient = this.messageItem.extra[index];
          if (recipient.delivery_status != "DELIVRD") {
            continue;
          }

          if (phoneNos != "") phoneNos += ", ";

          phoneNos += recipient.phone_no;
        }
      }
      return phoneNos;
    },
    copyUndeliveredRecipients() {
      let phoneNos = "";
      if (this.messageItem.extra instanceof Promise) {
        return "";
      } else {
        for (let index = 0; index < this.messageItem.extra.length; index++) {
          let recipient = this.messageItem.extra[index];
          if (recipient.delivery_status == "DELIVRD") {
            continue;
          }

          if (phoneNos != "") phoneNos += ", ";

          phoneNos += recipient.phone_no;
        }
      }
      return phoneNos;
    },
    totalDelivered() {
      let total = 0;
      if (this.messageItem.extra instanceof Promise) {
        return 0;
      } else {
        for (let index = 0; index < this.messageItem.extra.length; index++) {
          let recipient = this.messageItem.extra[index];
          if (recipient.delivery_status != "DELIVRD") {
            continue;
          }

          total++;
        }
      }
      return total;
    },
    totalBounced() {
      let total = 0;
      if (this.messageItem.extra instanceof Promise) {
        return 0;
      } else {
        for (let index = 0; index < this.messageItem.extra.length; index++) {
          let recipient = this.messageItem.extra[index];
          if (recipient.delivery_status == "DELIVRD") {
            continue;
          }

          total++;
        }
      }
      return total;
    }
  },
  methods: {
    ...mapActions("message", [
      "deleteSent",
      "resend",
      "deleteDraft",
      "resend",
      "sendDraft",
      "deleteSchedule",
      "toggleSchedule"
    ]),
    scrollHandle(evt) {
      // console.log(evt)
    },
    formartDate: function(date) {
      if (date.length > 16) {
        date = Vue.lodash
          .truncate(date, { length: 16, omission: "" })
          .replace("T", " ");
      }

      return date;
    },
    showMessageView: function() {
      this.$emit("show-message-view", this.message);
    },
    showMessageSelection: function() {
      this.$emit("show-message-selection", this.message);
    },
    onCopy: function(e) {
      this.copyNotifSuccess();
    },
    onCopyError: function(e) {
      this.copyNotifError();
    },
    handleReloadRecipients: function() {
      //this.$emit('newsletter-followup-delete', this.followup.id)
    },
    deleteOutboxMessage() {
      if (this.loading) {
        this.$swal("You have already clicked delete button");
        return;
      }

      this.$swal({
        title: "Delete message",
        text: "Sure you want to delete this message?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!"
      }).then(result => {
        if (result.value) {
          if (this.loading) return;

          let status = this.deleteSent({ id: this.messageItem.id });
          if (!status) {
            this.showDeleteError({ message: this.serverResponse.message });
          } else {
            this.showDeleteSuccess();
          }
        }
      });
    },
    resendMessage: function() {
      if (this.loading) {
        this.$swal("You have already clicked resend button");
        return;
      }

      this.$swal({
        title: "Resend message",
        text: "Sure you want to resend this message?",
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Resend it!"
      }).then(result => {
        if (result.value) {
          if (this.loading) return;

          let status = this.resend({ id: this.messageItem.id });
          if (!status) {
            this.showSendError({ message: this.serverResponse.message });
          } else {
            this.showSendSuccess();
          }
        }
      });
    },
    deleteDraftMessage() {
      if (this.loading) {
        this.$swal("You have already clicked delete button");
        return;
      }

      this.$swal({
        title: "Delete message",
        text: "Sure you want to delete this message?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!"
      }).then(result => {
        if (result.value) {
          if (this.loading) return;

          let status = this.deleteDraft({ id: this.messageItem.id });
          if (!status) {
            this.showDeleteError({ message: this.serverResponse.message });
          } else {
            this.showDeleteSuccess();
          }
        }
      });
    },
    sendDraftMessage: function() {
      if (this.loading) {
        this.$swal("You have already clicked resend button");
        return;
      }

      this.$swal({
        title: "Send message",
        text: "Sure you want to send this message?",
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Send it!"
      }).then(result => {
        if (result.value) {
          if (this.loading) return;

          let status = this.sendDraft({ id: this.messageItem.id });
          if (!status) {
            this.showSendError({ message: this.serverResponse.message });
          } else {
            this.showSendSuccess();
          }
        }
      });
    },
    deleteScheduleMessage() {
      if (this.loading) {
        this.$swal("You have already clicked delete button");
        return;
      }

      this.$swal({
        title: "Delete message",
        text: "Sure you want to delete this message?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!"
      }).then(result => {
        if (result.value) {
          if (this.loading) return;

          let status = this.deleteSchedule({ id: this.messageItem.id });
          if (!status) {
            this.showDeleteError({ message: this.serverResponse.message });
          } else {
            this.showDeleteSuccess();
          }
        }
      });
    }
  }
};
</script>

<style lang="scss">
#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.25rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }
}
.scroll-area {
  position: relative;
  height: calc(100vh - 13vh);
}
</style>
